import React from "react";
import FancyBearsContainer from "components/FancyBearsContainer";
import { Box } from "@chakra-ui/react";

const BearsListPage: React.FC = () => {
  return (
    <Box pt="12" pb="16">
      <FancyBearsContainer />
    </Box>
  );
};

export default BearsListPage;
